import { createContext, useContext, useState, useCallback } from "react";

const LeadContext = createContext(null);

export function LeadProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("demo"); // "demo" | "contact"

  const openLead = useCallback((m = "demo") => {
    setMode(m);
    setOpen(true);
  }, []);
  const closeLead = useCallback(() => setOpen(false), []);

  return (
    <LeadContext.Provider value={{ open, mode, openLead, closeLead }}>
      {children}
    </LeadContext.Provider>
  );
}

export function useLead() {
  const ctx = useContext(LeadContext);
  if (!ctx) throw new Error("useLead must be used within LeadProvider");
  return ctx;
}
